import { FC, ReactNode } from 'react';
import { cn } from '@/shared/lib';
import { Tooltip } from '../Tooltip';

/** Классы усечения по числу строк: динамическое имя класса Tailwind в сборку не попадает */
const CLAMP_CLASS = {
  1: 'truncate',
  2: 'line-clamp-2',
  3: 'line-clamp-3',
} as const;

type Props = {
  /** Текст; он же уходит в подсказку, когда не помещается целиком */
  children: ReactNode;
  /** Сколько строк занимает текст до усечения */
  lines?: keyof typeof CLAMP_CLASS;
  /** Содержимое подсказки, если полное значение отличается от видимого текста */
  tooltip?: ReactNode;
  className?: string;
};

/**
 * Текст, который усекается по месту и показывает полное значение подсказкой — только тогда, когда
 * действительно не поместился.
 *
 * Так полное значение доступно везде, где ширину задаёт раскладка (меню, ячейка таблицы, карточка
 * списка), и подсказка при этом не дублирует то, что и так видно целиком.
 *
 * Элемент блочный: усечение считается по его ширине, поэтому в строке из нескольких элементов он
 * должен получать её от раскладки (`flex` + `min-w-0` у родителя).
 */
export const TruncatedText: FC<Props> = ({ children, lines = 1, tooltip, className }) => (
  <Tooltip tooltip={tooltip ?? children} onlyWhenTruncated>
    <span className={cn('block min-w-0', CLAMP_CLASS[lines], className)}>{children}</span>
  </Tooltip>
);
